export function removeClassNameByIndex(element: HTMLElement, index: number) {
    if (element !== null && element.classList.length > index) {
        element.classList.remove(`${element.classList.item(index)}`);
    }
}
